import { render } from "./Paid.vue?vue&type=template&id=0253150a"
import script from "./Paid.vue?vue&type=script&lang=js"
export * from "./Paid.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Paid.vue?vue&type=style&index=1&id=0253150a&lang=css"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__